import { DISCOUNT_CODE } from 'config/api-routes';
import { PartialDiscountCodeType } from 'types/discount-code.types';
import { DELETE, GET, PATCH, POST } from 'utils/request';
import { formatResponse } from 'utils/service-helpers';

// former VoucherService
export default class DiscountCodeService {
  async getList(queryString?, opts = {}) {
    const response = await GET(DISCOUNT_CODE.LIST.GET(queryString), opts);

    return formatResponse(response);
  }

  async update(id: number, data: PartialDiscountCodeType, opts = {}) {
    const response = await PATCH(DISCOUNT_CODE.CHANGE.PATCH(id), data, opts);

    return formatResponse(response);
  }

  async delete(id: number, opts = {}) {
    const response = await DELETE(DISCOUNT_CODE.REMOVE.DELETE(id), {}, opts);

    return formatResponse(response);
  }

  async create(data: PartialDiscountCodeType, opts = {}) {
    const response = await POST(DISCOUNT_CODE.SAVE.POST(), data, opts);

    return formatResponse(response);
  }

  async confirm(shopId, code, data, opts = {}) {
    const response = await POST(DISCOUNT_CODE.ONE.CODE.POST(shopId, code), data, opts);

    return formatResponse(response);
  }
}
